import * as moment from 'moment';
import { AfterContentChecked, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cpfValidator } from '@shared/validators/cpf.validator';
import { Campo, FormComponent } from '@components/form/form.component';
import { modal } from '@shared/alerts/modal/modal.alert';
import { CondutorRepository } from '@data/condutor/condutor.repository';
import { MunicipioRepository } from '@app/data/municipio/municipio.repository';
import { FileData } from '@shared/components/anexos/file/file.component';
import { AnexoRepository } from '@data/anexo/anexo.repository';
import { AnexosComponent, AnexosOptions } from '@shared/components/anexos/anexos.component';
import { AuthService } from '@infra/auth/auth.service';
import { CategoriaCNHRepository } from '@app/data/categoria-cnh/categoria-cnh.repository';
import { PaisRepository } from '@app/data/pais/pais.repository';
import { TipoEnderecoRepository } from '@app/data/tipo-endereco/tipo-endereco.repository';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { PortalClienteRepository } from '@app/data/portal-cliente/portal-cliente.repository';
import { CepRepository } from '@app/data/cep/cep.repository';

@Component({
  selector: 'app-formulario-condutor',
  templateUrl: './formulario-condutor.component.html',
  styleUrls: ['./formulario-condutor.component.scss'],
})
export class FormularioCondutorComponent implements AfterContentChecked {

  protected loading: boolean = false;
  private ultimoCPF: string = '';

  @ViewChild('formCondutor') formCondutor: FormComponent | undefined = undefined;
  @ViewChild('formCNH') formCNH: FormComponent | undefined = undefined;
  @ViewChild('formEndereco') formEndereco: FormComponent | undefined = undefined;
  @ViewChild('formContato') formContato: FormComponent | undefined = undefined;
  @ViewChild('anexos') anexos: AnexosComponent | undefined;

  protected camposEndereco: Campo[] = [
    {
      name: 'id',
      label: 'id Endereço',
      type: 'text',
      width: '0%',
      hide: true,
      validators: [],
    },
    {
      name: 'pessoaId',
      label: 'id Pessoa',
      type: 'text',
      width: '0%',
      hide: true,
      validators: [],
    },
    {
      name: 'cep',
      label: 'CEP',
      type: 'text',
      mask: '00000-000',
      width: '30%',
      onChange: this.onCepChange.bind(this),
      validators: [Validators.required],
    },
    {
      name: 'logradouro',
      label: 'Logradouro',
      type: 'text',
      width: '70%',
      validators: [Validators.required],
    },
    {
      name: 'numero',
      label: 'Número',
      type: 'text',
      width: '30%',
      validators: [Validators.required],
    },
    {
      name: 'complemento',
      label: 'Complemento',
      type: 'text',
      width: '70%',
    },
    {
      name: 'bairro',
      label: 'Bairro',
      type: 'text',
      width: '50%',
      validators: [Validators.required],
    },
    {
      name: 'municipioId',
      label: 'Município',
      type: 'search',
      width: '50%',
      searchOptions: {
        key: 'descricao',
        primaryKey: 'id',
        format: (value: string) => value + '%',
        filter: this.municipioRepository.filter.bind(this.municipioRepository),
      },
      validators: [Validators.required],
    },
    {
      name: 'paisId',
      label: 'País',
      type: 'search',
      width: '50%',
      searchOptions: {
        key: 'descricao',
        primaryKey: 'id',
        format: (value: string) => value + '%',
        filter: this.paisRepository.filter.bind(this.paisRepository),
      },
      validators: [Validators.required],
    },
    {
      name: 'tipoEnderecoId',
      label: 'Tipo Endereço',
      type: 'search',
      width: '50%',
      searchOptions: {
        key: 'descricao',
        primaryKey: 'id',
        format: (value: string) => value + '%',
        filter: this.tipoEnderecoRepository.filter.bind(this.tipoEnderecoRepository),
      },
      validators: [Validators.required],
    }


  ];
  protected camposContato: Campo[] = [
    {
      name: 'id',
      label: 'id Contato',
      type: 'text',
      width: '0%',
      hide: true,
      validators: [],
    },
    {
      name: 'nome',
      label: 'Nome',
      type: 'text',
      width: '50%',
      validators: [Validators.required],
    },
    {
      name: 'telefone',
      label: 'Telefone',
      type: 'telefone',
      width: '50%',
      validators: [Validators.required],
    },
    {
      name: 'email',
      label: 'Email',
      type: 'text',
      width: '70%',
      validators: [Validators.email],
    }
  ];

  protected camposDadosPessoa: Campo[] = [
    {
      name: 'pessoa.id',
      label: 'Código da Pessoa',
      type: 'text',
      width: '0%',
      hide: true,
      validators: [],
    },
    {
      name: 'pessoa.cpf',
      label: 'CPF',
      type: 'text',
      mask: '000.000.000-00',
      width: '30%',
      onChange: this.getCondutorByCPF.bind(this),
      validators: [Validators.required, cpfValidator],
    },
    {
      name: 'pessoa.estrangeiro',
      label: 'Estrangeiro',
      type: 'select',
      width: (100 / 4) + '%',
      selectOptions: {
        items: [
          { value: 'S', label: 'Sim' },
          { value: 'N', label: 'Não' },
        ],
      },
      onChange: (value: string) => {
        this.setEstrangeiro(value);
      },
      validators: [Validators.required],
    },
    {
      name: 'pessoa.passaporte',
      label: 'Passaporte',
      disabled: true,
      type: 'text',
      width: '45%',
    },
    {
      name: 'pessoa.razaoSocial',
      label: 'Nome',
      type: 'text',
      width: '50%',
      validators: [Validators.required],
    },
    {
      name: 'pessoa.dataNascimento',
      label: 'Data de Nascimento',
      type: 'date',
      dateOptions: {
        icon: 'suffix',
        maxDate: moment().subtract(18, 'years'),
      },
      width: '50%',
      validators: [Validators.required],
    },
    {
      name: 'pessoa.rg',
      label: 'RG',
      type: 'text',
      mask: '0*',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'pessoa.orgaoEmissorRg',
      label: 'Órgão Emissor RG',
      type: 'text',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'nomeMae',
      label: 'Nome Mãe',
      type: 'text',
      width: 'calc(100% / 3)',
    },
    {
      name: 'pessoa.telefone',
      label: 'Telefone',
      type: 'telefone',
      width: '50%',
    },
  ];

  protected camposDadosCNH: Campo[] = [
    {
      name: 'id',
      label: 'Código do Condutor',
      type: 'text',
      width: '0%',
      hide: true,
      validators: [],
    },
    {
      name: 'numeroCNH',
      label: 'Nº CNH',
      type: 'text',
      mask: '0*',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'registroCNH',
      label: 'Nº Registro CNH',
      type: 'text',
      mask: '0*',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'numeroSegurancaCNH',
      label: 'Nº Segurança CNH',
      type: 'text',
      mask: '0*',
      width: 'calc(100% / 3)',
      validators: [Validators.required],
    },
    {
      name: 'categoriaId',
      label: 'Categoria',
      type: 'select',
      width: '30%',
      selectOptions: {
        filter: this.categoriaCnhRepository.filter.bind(this.categoriaCnhRepository),
      },
      validators: [Validators.required],
    },
    {
      name: 'orgaoCNH',
      label: 'Órgão Emissor CNH',
      type: 'text',
      width: '30%',
      validators: [Validators.required],
    },
    {
      name: 'dataValidadeCNH',
      label: 'Validade',
      type: 'date',
      dateOptions: {
        icon: 'suffix',
        minDate: moment(),
        maxDate: moment().add(10, 'years'),
      },
      width: '40%',
      validators: [Validators.required],
    },
    {
      name: 'dataPrimeiraHabilitacao',
      label: 'Data Primeira Habilitação',
      type: 'date',
      dateOptions: {
        icon: 'suffix',
        maxDate: moment(),
      },
      width: '40%',
      validators: [Validators.required],
    },
    {
      name: 'municipioEmissorCNHId',
      label: 'Município',
      type: 'search',
      width: '60%',
      searchOptions: {
        key: 'descricao',
        primaryKey: 'id',
        format: (value: string) => value + '%',
        filter: this.municipioRepository.filter.bind(this.municipioRepository),
      },
      validators: [Validators.required],
    },
  ];

  protected anexosOptions: AnexosOptions = {
    disableDelete: !this.authService.hasPermission('condutor', 'DELETAR'),
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { id: string },
    private dialogRef: MatDialogRef<any>,
    private authService: AuthService,
    private condutorRepository: CondutorRepository,
    private municipioRepository: MunicipioRepository,
    private paisRepository: PaisRepository,
    private tipoEnderecoRepository: TipoEnderecoRepository,
    private anexoRepository: AnexoRepository,
    private changeDetector: ChangeDetectorRef,
    private portalClienteRepository: PortalClienteRepository,
    private categoriaCnhRepository: CategoriaCNHRepository,
    private cepRepository: CepRepository,
  ) {
    if (data) {
      this.getCondutorById(data.id);
    }
  }

  protected get isFormValid() {
    return (
      this.formCondutor?.isValid &&
      this.formCNH?.isValid &&
      this.formEndereco?.isValid &&
      this.formContato?.isValid
    );
  }

  protected get isEdit() {
    return !!this.data?.id;
  }

  protected get title() {
    return this.isEdit ? 'Editar Condutor' : 'Novo Condutor';
  }

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();

  }

  protected onCepChange(cep: string): void {
    const cleanCep = (cep || '').replace(/\D/g, '');
    if (cleanCep.length < 8) {
      return;
    }

    this.loading = true;

    this.cepRepository.buscarPorCep(cleanCep).subscribe({
      next: (res) => {
        if (!res || res.erro) {
          modal.fire({
            icon: 'warning',
            title: 'CEP Inválido',
            html: 'CEP não encontrado. Por favor, verifique o código informado.',
          });

          if (this.formEndereco?.form) {
            const cepControl = this.formEndereco.form.get('cep');
            if (cepControl) {
              cepControl.setErrors({ cepInvalido: true });
            }
            this.formEndereco.form.patchValue({
              logradouro: '',
              bairro: '',
            });
          }
          return;
        }

        if (this.formEndereco?.form) {
          const cepControl = this.formEndereco.form.get('cep');
          if (cepControl?.hasError('cepInvalido')) {
            const currentErrors = { ...cepControl.errors };
            delete currentErrors['cepInvalido'];
            cepControl.setErrors(Object.keys(currentErrors).length > 0 ? currentErrors : null);
          }

          this.formEndereco.form.patchValue({
            logradouro: res.logradouro || '',
            bairro: res.bairro || '',
          });

          if (res.localidade) {
            const queryBusca = res.ibge ? `codigoIBGE=${res.ibge}` : `descricao=${res.localidade}%`;
            this.municipioRepository.filter(queryBusca).subscribe({
              next: (municipios) => {
                if (municipios?.length > 0) {
                  const municipioEncontrado = municipios.find(m =>
                    res.uf ? m.label.toLowerCase().includes(res.uf.toLowerCase()) : true
                  ) || municipios[0];

                  if (municipioEncontrado) {
                    this.formEndereco?.form.patchValue({
                      municipioId: municipioEncontrado.value
                    });
                  }
                }
              }
            });
          }
        }
      },
      error: () => {
        modal.fire({
          icon: 'error',
          title: 'Erro de Validação',
          html: 'Não foi possível validar o CEP informado no momento.',
        });
      }
    }).add(() => { this.loading = false; });
  }

  ngOnInit(): void {
    this.getCamposObrigatoriosPortalCliente();
  }

  getCamposObrigatoriosPortalCliente(): void {
    this.portalClienteRepository.getCamposObrigatorios().subscribe({
      next: (camposAPI) => {
        if (camposAPI && camposAPI.length > 0) {
          this.aplicarObrigatoriedadeDinamica(camposAPI);
        }
      },
      error: (err) => console.error('Erro ao carregar campos obrigatórios', err)
    });
  }

  private aplicarObrigatoriedadeDinamica(camposAPI: any[]): void {
    camposAPI.forEach(config => {
      const nomeDoCampo = config.campo; 
      const deveSerObrigatorio = config.obrigatorio === 'S'; 

      this.atualizarValidatorNoArray(nomeDoCampo, deveSerObrigatorio);
    });


    setTimeout(() => {
      camposAPI.forEach(config => {
        const nomeDoCampo = config.campo; 
        const deveSerObrigatorio = config.obrigatorio === 'S'; 
        
        this.atualizarValidatorNoFormControl(nomeDoCampo, deveSerObrigatorio);
      });
    }, 100); 
  }
  private atualizarValidatorNoArray(nomeCampo: string, isObrigatorio: boolean): void {
    const mapasDeCampos = [
      { array: this.camposEndereco, atualizar: (novoArray: Campo[]) => this.camposEndereco = novoArray },
      { array: this.camposContato, atualizar: (novoArray: Campo[]) => this.camposContato = novoArray },
      { array: this.camposDadosPessoa, atualizar: (novoArray: Campo[]) => this.camposDadosPessoa = novoArray },
      { array: this.camposDadosCNH, atualizar: (novoArray: Campo[]) => this.camposDadosCNH = novoArray },
    ];

    mapasDeCampos.forEach(mapa => {

      const index = mapa.array.findIndex(c => c.name === nomeCampo);
      
      if (index !== -1) {
        const campoAtualizado = { ...mapa.array[index] };
        
        if (!campoAtualizado.validators) campoAtualizado.validators = [];
        
        const jaPossuiRequired = campoAtualizado.validators.includes(Validators.required);
        let alterou = false;

        if (isObrigatorio && !jaPossuiRequired) {
          campoAtualizado.validators = [...campoAtualizado.validators, Validators.required];
          alterou = true;
        } else if (!isObrigatorio && jaPossuiRequired) {
          campoAtualizado.validators = campoAtualizado.validators.filter(v => v !== Validators.required);
          alterou = true;
        }


        if (alterou) {
          const novoArrayCompleto = [...mapa.array];
          novoArrayCompleto[index] = campoAtualizado;
          

          mapa.atualizar(novoArrayCompleto); 
        }
      }
    });
  }

  private atualizarValidatorNoFormControl(nomeCampo: string, isObrigatorio: boolean): void {
    const formulariosBase = [
      this.formCondutor, 
      this.formCNH, 
      this.formEndereco, 
      this.formContato
    ];
    
    let controleEncontrado = false;

    formulariosBase.forEach(formComponent => {
      if (formComponent && formComponent.form) {
        const control = formComponent.form.get(nomeCampo);
        
        if (control) {
          controleEncontrado = true;
          if (isObrigatorio && !control.hasValidator(Validators.required)) {
            control.addValidators(Validators.required); 
          } else if (!isObrigatorio && control.hasValidator(Validators.required)) {
            control.removeValidators(Validators.required); 
          }
          control.updateValueAndValidity({ emitEvent: false }); 
        }
      }
    });

    if (!controleEncontrado) {
      console.warn(`Atenção: O FormControl para '${nomeCampo}' não foi encontrado nos formulários. Verifique se o nome bate com o da API.`);
    }
  }
  
  private getCondutorById(id: string) {
    this.loading = true;

    this.condutorRepository.getByIdRequest<{ data: any }>(id).subscribe({
      next: (result) => {
        if (result.data) {

          if (this.formCondutor) this.formCondutor.load(result.data);
          if (this.formCNH) this.formCNH.load(result.data);

          if (this.formEndereco && result.data.pessoa?.enderecos?.length > 0) {
            const enderecos = result.data.pessoa.enderecos;
            const enderecoPrincipal = enderecos.find((e: any) => e.principal === 'S') || enderecos[0];
            this.formEndereco.load(enderecoPrincipal);
          }

          if (this.formContato && result.data.pessoa?.contatos?.length > 0) {
            const contatos = result.data.pessoa.contatos;
            const contatoPrincipal = contatos.find((c: any) => c.principal === 'S') || contatos[0];
            this.formContato.load(contatoPrincipal);
          }
          this.anexoRepository.getAnexos('Condutores', id).subscribe((data) => {
            if (this.anexos) {
              this.anexos.setSentFiles(data);
            }
          });
        }

        this.ultimoCPF = result.data?.pessoa?.cpf;
        this.setEstrangeiro(result.data?.pessoa?.estrangeiro);
      },
      error: (err) => {
        console.error('Falha ao carregar dados do condutor:', err);
      }
    }).add(() => { this.loading = false; });
  }

  private getCondutorByCPF(cpf: string) {
    if (cpf?.length >= 11 && this.ultimoCPF !== cpf) {
      this.loading = true;

      this.condutorRepository.getByCPF(cpf).subscribe({
        next: (result) => {
          if (!this.formCondutor || !this.formCNH) return;

          const possuiPermicao = this.authService.hasPermission('condutor', 'EDITAR');

          if (!possuiPermicao && result.data?.id) {
            modal.fire({
              icon: 'warning',
              title: 'Atenção',
              html: 'Já existe um condutor cadastrado com esse CPF, porém você não possui permissão para editá-lo.',
            });

            const control = this.formCondutor.form.get<any>(['pessoa.cpf']);

            if (control) {
              control.setValue('');
            }
          } else if (result.data?.id) {
            this.data = { id: result.data.id };
            this.formCondutor.load(result.data);
            this.formCNH.load(result.data);

            this.anexoRepository.getAnexos('Condutores', result.data.id).subscribe((data) => {
              if (this.anexos) {
                this.anexos.setSentFiles(data);
              }
            });

            this.ultimoCPF = cpf;
          }
        }
      }).add(() => { this.loading = false });
    }
  }

  protected onSubmit(formPessoa: any, formCNH: any, formEndereco: any, formContato: any) {
    // Função auxiliar para resgatar o valor independente de como o <app-form> constrói o objeto
    const getVal = (form: any, key: string, prop: string) =>
      form?.[key] ?? form?.pessoa?.[prop] ?? null;

    // Montagem exata do payload aguardado pelo backend
    const condutor = {
      id: this.data?.id,
      pessoaId: getVal(formPessoa, 'pessoa.id', 'id'),
      numeroCNH: formCNH?.numeroCNH,
      registroCNH: formCNH?.registroCNH,
      numeroSegurancaCNH: formCNH?.numeroSegurancaCNH,
      categoriaId: formCNH?.categoriaId,
      dataValidadeCNH: formCNH?.dataValidadeCNH,
      dataPrimeiraHabilitacao: formCNH?.dataPrimeiraHabilitacao,
      orgaoCNH: formCNH?.orgaoCNH,
      municipioEmissorCNHId: formCNH?.municipioEmissorCNHId,
      nomeMae: formPessoa?.nomeMae,
      pessoa: {
        cpf: getVal(formPessoa, 'pessoa.cpf', 'cpf'),
        razaoSocial: getVal(formPessoa, 'pessoa.razaoSocial', 'razaoSocial'),
        dataNascimento: getVal(formPessoa, 'pessoa.dataNascimento', 'dataNascimento'),
        rg: getVal(formPessoa, 'pessoa.rg', 'rg'),
        orgaoEmissorRg: getVal(formPessoa, 'pessoa.orgaoEmissorRg', 'orgaoEmissorRg'),
        estrangeiro: getVal(formPessoa, 'pessoa.estrangeiro', 'estrangeiro'),
        passaporte: getVal(formPessoa, 'pessoa.passaporte', 'passaporte'),
        telefone: getVal(formPessoa, 'pessoa.telefone', 'telefone'),
        id: getVal(formPessoa, 'pessoa.id', 'id'),
        enderecos: [
          {
            id: getVal(formEndereco, 'id', 'id'),
            cep: getVal(formEndereco, 'cep', 'cep'),
            logradouro: getVal(formEndereco, 'logradouro', 'logradouro'),
            numero: getVal(formEndereco, 'numero', 'numero'),
            complemento: getVal(formEndereco, 'complemento', 'complemento'),
            bairro: getVal(formEndereco, 'bairro', 'bairro'),
            municipioId: getVal(formEndereco, 'municipioId', 'municipioId'),
            paisId: getVal(formEndereco, 'paisId', 'paisId'),
            principal: 'S',
            tipoEnderecoId: getVal(formEndereco, 'tipoEnderecoId', 'tipoEnderecoId')
          }
        ],
        contatos: [
          {
            id: getVal(formContato, 'id', 'id'),
            nome: getVal(formContato, 'nome', 'nome'),
            telefone: getVal(formContato, 'telefone', 'telefone'),
            email: getVal(formContato, 'email', 'email'),
            principal: 'S'
          }
        ]
      }
    };

    this.loading = true;

    if (this.isEdit) {
      this.condutorRepository.putRequest(this.data.id, condutor).subscribe({
        next: () => {
          if (this.anexos) {
            const subs = []

            if (this.anexos.files.length > 0) {
              subs.push(this.anexarArquivos(this.data.id, this.anexos.files));
            }

            if (this.anexos.deletedFiles.length > 0) {
              subs.push(this.deletarArquivos(this.anexos.deletedFiles));
            }

            if (subs.length === 0) {
              this.dialogRef.close(condutor);
            } else {
              forkJoin(subs).subscribe({
                next: () => { this.dialogRef.close(condutor) },
                error: () => {
                  modal.fire({
                    icon: 'error',
                    title: 'Erro ao salvar anexos',
                    html: 'Tente novamente mais tarde ou contate o suporte técnico',
                  });

                  this.dialogRef.close();
                }
              });
            }
          }
        },
        error: (error) => {
          modal.fire({
            icon: error.icon,
            title: error.title,
            html: error.message,
          });
        },
      }).add(() => { this.loading = false });;
    } else {
      this.condutorRepository.postRequest(condutor).subscribe({
        next: () => {
          this.dialogRef.close(condutor)
        },
        error: (error) => {
          modal.fire({
            icon: error.icon,
            title: error.title,
            html: error.message,
          });
        },
      }).add(() => { this.loading = false });;
    }
  }

  private anexarArquivos(id: string, anexos: FileData[]) {
    return this.anexoRepository.postAnexos('Condutores', id, anexos);
  }

  private deletarArquivos(anexos: FileData[]) {
    const observables = [];

    for (const anexo of anexos) {
      if (anexo.id) {
        observables.push(this.anexoRepository.deleteRequest(anexo.id));
      }
    }

    return forkJoin(observables);
  }

  protected close(): void {
    this.dialogRef.close();
  }

  setEstrangeiro(estrangeiro: any) {
    // controladores condutor
    const controlCPF = this.formCondutor?.form.get<any>(['pessoa.cpf']);
    const controlRG = this.formCondutor?.form.get<any>(['pessoa.rg']);
    const controlOrgaoEmissor = this.formCondutor?.form.get<any>(['pessoa.orgaoEmissorRg']);
    const controlPassaporte = this.formCondutor?.form.get<any>(['pessoa.passaporte']);

    // controladores cnh
    const controlNumeroCNH = this.formCNH?.form.get<any>(['numeroCNH']);
    const controlRegistroCNH = this.formCNH?.form.get<any>(['registroCNH']);
    const controlNumeroSegurancaCNH = this.formCNH?.form.get<any>(['numeroSegurancaCNH']);
    const controlOrgaoCNH = this.formCNH?.form.get<any>(['orgaoCNH']);
    const controlDataValidadeCNH = this.formCNH?.form.get<any>(['dataValidadeCNH']);
    const controldataPrimeiraHabilitacao = this.formCNH?.form.get<any>(['dataPrimeiraHabilitacao']);
    const controlMunicipioEmissorCNHId = this.formCNH?.form.get<any>(['municipioEmissorCNHId']);

    if (estrangeiro == 'S') {
      controlCPF?.setValue(null);
      controlRG?.setValue(null);
      controlOrgaoEmissor?.setValue(null);
      controlNumeroCNH?.setValue(null);
      controlRegistroCNH?.setValue(null);
      controlNumeroSegurancaCNH?.setValue(null);
      controlOrgaoCNH?.setValue(null);
      controlDataValidadeCNH?.setValue(null);
      controldataPrimeiraHabilitacao?.setValue(null);
      controlMunicipioEmissorCNHId?.setValue(null);


      controlCPF?.disable();
      controlRG?.disable();
      controlOrgaoEmissor?.disable();
      controlNumeroCNH?.disable();
      controlRegistroCNH?.disable();
      controlNumeroSegurancaCNH?.disable();
      controlOrgaoCNH?.disable();
      controlDataValidadeCNH?.disable();
      controldataPrimeiraHabilitacao?.disable();
      controlMunicipioEmissorCNHId?.disable();

      controlPassaporte?.enable();

    } else {
      controlCPF?.enable();
      controlRG?.enable();
      controlOrgaoEmissor?.enable();
      controlNumeroCNH?.enable();
      controlRegistroCNH?.enable();
      controlNumeroSegurancaCNH?.enable();
      controlOrgaoCNH?.enable();
      controlDataValidadeCNH?.enable();
      controldataPrimeiraHabilitacao?.enable();
      controlMunicipioEmissorCNHId?.enable();
      controlPassaporte?.disable();
      controlPassaporte?.setValue(null);
    }
  }

  protected onStepChange(event: StepperSelectionEvent) {
    // Verifica se é um cadastro novo e se o usuário clicou na aba "Contato" (Índice 3)
    // Índices: 0=Pessoais, 1=CNH, 2=Endereço, 3=Contato
    if (!this.isEdit && event.selectedIndex === 3) {
      
      // Resgata os valores que o usuário digitou na aba "Dados Pessoais"
      const nomePessoa = this.formCondutor?.form.get(['pessoa.razaoSocial'])?.value;
      const telefonePessoa = this.formCondutor?.form.get(['pessoa.telefone'])?.value;

      // Pega os controles da aba de Contato
      const controlNomeContato = this.formContato?.form.get(['nome']);
      const controlTelefoneContato = this.formContato?.form.get(['telefone']);

      // Se existir o nome da pessoa E o contato ainda estiver vazio, copia o valor
      if (nomePessoa && !controlNomeContato?.value) {
        controlNomeContato?.setValue(nomePessoa);
        controlNomeContato?.updateValueAndValidity();
      }

      // Mesma coisa para o telefone
      if (telefonePessoa && !controlTelefoneContato?.value) {
        controlTelefoneContato?.setValue(telefonePessoa);
        controlTelefoneContato?.updateValueAndValidity();
      }
    }
  }
}
